import { render, staticRenderFns } from "./Psy.vue?vue&type=template&id=0cd82126&scoped=true&"
import script from "./Psy.vue?vue&type=script&lang=js&"
export * from "./Psy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cd82126",
  null
  
)

export default component.exports